import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_APPLESMS_SUCCESS,
  DELETE_APPLESMS_SUCCESS,
  GET_APPLESMS_FAIL,
  GET_APPLESMS_SUCCESS,
  UPDATE_APPLESMS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  applesms: [],
  defective: [],
  exports: [],
  error: {},
};

const APPLESMS = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_APPLESMS_SUCCESS:
      return {
        ...state,
        applesms: action.payload.applesms,
        defective: action.payload.defective,
      };

    case GET_APPLESMS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_APPLESMS_SUCCESS:
      return {
        ...state,
        applesms: [...state.applesms, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_APPLESMS_SUCCESS:
      return {
        ...state,
        applesms: state.applesms.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_APPLESMS_SUCCESS:
      return {
        ...state,
        applesms: state.applesms.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default APPLESMS;
